import { Component } from '@theme/component';

/**
 * @typedef {{ video: HTMLVideoElement, poster?: HTMLElement }} Refs
 */

/** @extends {Component<Refs>} */
export class TrustedByVideoCardComponent extends Component {
    /** @type {string[]} */
    requiredRefs = ['video'];

    playVideo() {
        this.refs.poster?.classList.remove('is--active-poster');
        const playAttempt = this.refs.video.play();
        if (playAttempt) {
            playAttempt.catch(() => {});
        }
    }
}

if (!customElements.get('trusted-by-video-card-component')) {
    customElements.define('trusted-by-video-card-component', TrustedByVideoCardComponent);
}

if (!customElements.get('trusted-by-video-card')) {
    class TrustedByVideoCardAlias extends TrustedByVideoCardComponent {}
    customElements.define('trusted-by-video-card', TrustedByVideoCardAlias);
}
